import { IProperty } from "src/constants/global-interfaces"
import { Page } from "src/providers/tabs/tabs-meta"

export interface DevicePushNotification {
    title: string,
    body: string,
    click_action: NotificationAction,
    associated_page: NotificationOpenPage,
    associated_entry_id: string,
    additional?: string
    created_by: string,
    created_at: Date,
    dbi: string,
    type: NotificationType,
}

export interface PushNotificationAndroid extends DevicePushNotification { }

export interface PushNotificationIOS extends DevicePushNotification {
    aps: {
        alert: {
            title: string,
            body: string,
        }
    },
}

export interface CommonPushNotification {
    title: string,
    description: string,
    clickAction: NotificationAction,
    associatedEntryId: string,
    associatedPage: NotificationOpenPage,
    clickNotification: boolean,
    createdBy: string,
    createdAt: Date,
    databaseIdentifier: string,
    type: NotificationType,
    additional: any,
}

export interface OpenPageDetails {
    page: NotificationOpenPage,
    details?: any
}

export enum NotificationAction {
    None = 0,
    OpenPage
}

export enum NotificationOpenPage {
    None = 0,
    EnquiriesPage,
    RequestsPage,
    StatisticsPage,
    PinboardPage,
    PresenceMonitoringPage,
    MessagesPage,
}

export enum NotificationType {
    None = 0,
    DutiesChanged,
    Info,
    MessageReply = 5,
    NewNotificationFromRota = 6,
    Statistic,
    EnquiryMessage,
    RequestMessage,
    PinboardPost,
    DutyMessage,
    PresenceMonitoring,
    EnquiryApplication,
}

export const PAGE_NOTIFICATION_MAPPER: IProperty<NotificationType[]> = {
    // singleuser
    [Page.SingleuserDuties]: [
        NotificationType.DutiesChanged,
        NotificationType.DutyMessage,
    ],
    [Page.SingleuserPinboard]: [
        NotificationType.PinboardPost,
    ],
    [Page.SingleuserNews]: [
        NotificationType.MessageReply,
        NotificationType.NewNotificationFromRota,
        NotificationType.DutiesChanged,
        NotificationType.DutyMessage,
        NotificationType.PinboardPost,
        NotificationType.RequestMessage,
        NotificationType.EnquiryMessage,
        NotificationType.EnquiryApplication,
        NotificationType.Statistic,
    ],
    [Page.SingleuserMore]: [
        NotificationType.Info,
        NotificationType.PresenceMonitoring,
        NotificationType.RequestMessage,
        NotificationType.EnquiryMessage,
        NotificationType.EnquiryApplication,
        NotificationType.Statistic,
    ],
    [Page.SingleuserMonitoring]: [
        NotificationType.PresenceMonitoring,
    ],

    // multiuser
    [Page.MultiuserPinboard]: [
        NotificationType.PinboardPost,
    ],
    [Page.MultiuserMore]: [
        NotificationType.Info,
    ],
}